import { useEffect, useRef, useState, useContext } from "react";
import styles from "./style.module.scss";

import { format, startOfMonth, endOfMonth, eachDayOfInterval } from "date-fns";
import { ru } from "date-fns/locale";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";

import { useNavigate } from "react-router-dom";
import logo from "../../assets/image/Frame.png";
import Image from "../../assets/image/cosmo.png";
import Detected from "../../assets/image/detected1.png";

import { MainContext } from "../../context/MainContext";
import { setService } from "../../helpers/setService";

const getMonthDays = () => {
  const now = new Date();
  return eachDayOfInterval({
    start: startOfMonth(now),
    end: endOfMonth(now),
  }).map((date) => format(date, "dd.MM.yyyy"));
};

export default function Slider() {
  const swiperRef = useRef(null);
  const { markers, serviceByDate, setServiceByDate } = useContext(MainContext);
  const [activeIndex, setActiveIndex] = useState();
  // const [ setSelectedDate] = useState(null);
  const [selected, setSelected] = useState();
  const navigate = useNavigate();

  const datesArray = getMonthDays();

  const todayString = format(new Date(), "dd.MM.yyyy");
  const initialIndex = datesArray.indexOf(todayString);

  useEffect(() => {
    const res = setService(markers);
    setServiceByDate(res.reverse());
  }, [markers, setServiceByDate]);

  const handleDayClick = (date) => {
    const dateString = format(date, "dd.MM.yyyy");
    // setSelectedDate(dateString);

    const index = datesArray.indexOf(dateString);
    if (index !== -1 && swiperRef.current) {
      swiperRef.current.slideTo(index);
    }
  };

  const findMarker = (name) => {
    const find = markers.find((marker) => marker.id === name);
    return find;
  };

  const filteredItems = (num) =>
    serviceByDate.filter((item) => {
      const [day, month, year] = num.split(".");
      return format(new Date(`${year}-${month}-${day}`), "d.M.yyyy") === item.date;
    });

  return (
    <div className={styles.slider}>
      <div className={styles.objects__banner}>
        <div className={styles.objects__banner__content}>
          <img className={styles.objects__banner__logo} src={logo} alt="logo" />
          <div>
            <h3 className={styles.objects__banner__content_title}>FIRE SAFETY</h3>
            <p className={styles.objects__banner__content_text}>Center</p>
          </div>
        </div>
        <div className={styles.objects__profile}>
          <button className={styles.objects__profile__btn} onClick={() => navigate("/")}>
            Return
          </button>
        </div>
      </div>
      <div className={styles.slider__container}>
        <div
          className={`flex flex-col items-center p-5 bg-gray-100 min-h-screen ${styles.slider__dp}`}
        >
          <DayPicker
            mode="single"
            locale={ru}
            selected={selected}
            onSelect={setSelected}
            onDayClick={handleDayClick}
            modifiers={{
              hasEvent: (el) => serviceByDate.some((item) => item.date === format(el, "d.M.yyyy")),
            }}
            modifiersStyles={{
              hasEvent: { backgroundColor: "#d32f2f", color: "white", borderRadius: "8px" },
            }}
            classNames={{
              caption: "text-lg font-bold text-gray-800",
              nav_button: "text-gray-500 hover:text-black",
              day_today: "text-red-600 font-bold",
              day_selected: "bg-blue-500 text-white rounded-lg",
            }}
            style={{ display: "flex", justifyContent: "center" }}
          />
        </div>
        <div
          className="relative flex items-center justify-center h-screen bg-gray-100"
          style={{ marginBottom: 20 }}
        >
          <Swiper
            effect="coverflow"
            initialSlide={initialIndex}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView="auto"
            spaceBetween={30}
            coverflowEffect={{
              rotate: 20,
              stretch: 0,
              depth: 150,
              modifier: 2,
              slideShadows: false,
            }}
            navigation={{
              prevEl: ".swiper-button-prev",
              nextEl: ".swiper-button-next",
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
            modules={[EffectCoverflow, Navigation]}
            className={styles.slider__swiper}
          >
            {datesArray?.map((num, index) => (
              <SwiperSlide key={num} className={styles.slider__slide}>
                <div
                  className={`h-full flex items-center justify-center text-white font-bold text-2xl rounded-xl transition-all duration-300 
              ${index === activeIndex ? styles.slider__slide__active : styles.slider__slide__dis}`}
                >
                  {filteredItems(num).length === 0 ? (
                    <p className={styles.slider__slide__date}>{num}</p>
                  ) : (
                    <p className={styles.slider__slide__date}>
                      {num}   TO: {filteredItems(num).flatMap((item) => item.ids.length)}шт
                    </p>
                  )}

                  {filteredItems(num).length === 0 ? (
                    <div className={styles.slider__slide__list_item__detected}>
                      <img
                        src={Detected}
                        className={styles.slider__slide__list_item__detected_img}
                        alt="detected"
                      />
                      <p className={styles.slider__slide__list_item__detected_text}>
                        Работы по Техническому Обслуживанию не проводились
                      </p>
                    </div>
                  ) : (
                    <div
                      className={styles.slider__slide__list__wrapper}
                    >
                      {filteredItems(num).flatMap((item) =>
                        item.ids.map((name, index) => (
                          <span key={index}>
                            <div className={styles.slider__slide__list_item}>
                              <img
                                className={styles.slider__slide__list_item__img}
                                src={findMarker(name).photo}
                                alt="images"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = Image;
                                }}
                              />
                              <div className={styles.slider__slide__list_item__box}>
                                <p className={styles.slider__slide__list_item__box__title}>
                                  {findMarker(name).name}
                                </p>
                                <p className={styles.slider__slide__list_item__box__text}>
                                  {findMarker(name).address}
                                </p>
                              </div>
                            </div>
                          </span>
                        ))
                      )}
                    </div>
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}
